const API_ROUTES = Object.freeze({
  REVIEW_CLASSIFICATIONS: "/api/ml-exports/review/classifications/",
  CONFIGS_CLASSIFICATION: "/api/ml-exports/configs/classification/",
  DESTINATIONS: "/api/ml-exports/destinations/",
  PROJECTS: "/api/ml-exports/projects/",
  RUNS: "/api/ml-exports/runs/",
  RUNS_PLAN: "/api/ml-exports/runs/plan/",
  RUNS_HISTORY: "/api/ml-exports/runs/history/",
  REVIEW_ACTIVITY: "/api/ml-exports/review/activity/",
  CLASSIFICATION_TAXONOMY: "/api/ml-exports/classification/taxonomy/",
  OBJECT_PRESENCE_TAXONOMY: "/api/ml-exports/object-presence/taxonomy/",
});

const QUERY_KEYS = Object.freeze({
  REVIEW_CLASSIFICATIONS: "ml-review-classifications",
  REVIEW_DETAIL: "ml-review-detail",
  CONFIGS: "ml-export-configs",
  CONFIG_DETAIL: "ml-export-config-detail",
  DESTINATIONS: "ml-export-destinations",
  PROJECTS: "ml-export-projects",
  RUNS_HISTORY: "ml-export-runs-history",
  RUN_DETAIL: "ml-export-run-detail",
  REVIEW_ACTIVITY: "ml-review-activity",
  CLASSIFICATION_TAXONOMY: "ml-classification-taxonomy-v2",
  OBJECT_PRESENCE_TAXONOMY: "ml-object-presence-taxonomy",
});

export { API_ROUTES, QUERY_KEYS };
